import type { Region } from '@libs/contexts';
import { useUser } from '@libs/contexts';
import { RestClient } from '@libs/rest-client';
import { ExpandLess, ExpandMore, StarBorder } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemIcon } from '@mui/material';
import { useTry } from '@ps-smart-cp/ppfw-client';
import { useNavigate } from 'react-router';
import { ListItemText } from './ListItemText';

interface CompanyMenuItemProps {
  index: number;
  currentValid: number | null;
  setCurrentValid: (c: number | null) => void;
  companyCode: string;
  companyName: string;
  regions: Region[];
  onClose: () => void;
}

function CompanyMenuItem(props: CompanyMenuItemProps) {
  const { index, currentValid, setCurrentValid, companyCode, companyName, regions } = props;
  const { reloadApp } = useUser();
  const navigate = useNavigate();
  const open = index === currentValid;
  const { wrapRequestInTry } = useTry();

  return (
    <>
      <ListItemButton
        id={`company-${companyCode}`}
        disableRipple
        onClick={() => setCurrentValid(currentValid === null ? index : currentValid === index ? null : index)}
      >
        <ListItemText
          // TODO: AUTH-1499 会社切替のボタンにカーソルを合わせるとツールチップで会社名称を表示する
          primary={`${companyCode}\u00A0\u00A0${companyName}`}
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '200px',
          }}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {regions.map((r) => (
            <ListItemButton
              key={`${companyCode}-${r}`}
              id={`${companyCode}-${r}`}
              sx={{ pl: 4 }}
              onClick={wrapRequestInTry(async () => {
                await RestClient.auth.post('/switch-subsystem', {
                  companyCode,
                  region: r,
                });
                reloadApp();
                navigate(`/${r}/main-menu`);
              })}
            >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary={r.toUpperCase()} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
}

export { CompanyMenuItem };
